var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTradechartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4645 15.4645C14 16.9289 14 19.286 14 24C14 28.714 14 31.0711 15.4645 32.5355C16.9289 34 19.286 34 24 34C28.714 34 31.0711 34 32.5355 32.5355C34 31.0711 34 28.714 34 24C34 19.286 34 16.9289 32.5355 15.4645C31.0711 14 28.714 14 24 14C19.286 14 16.9289 14 15.4645 15.4645ZM29 20.25C29.4142 20.25 29.75 20.5858 29.75 21V30C29.75 30.4142 29.4142 30.75 29 30.75C28.5858 30.75 28.25 30.4142 28.25 30V21C28.25 20.5858 28.5858 20.25 29 20.25ZM24.75 24C24.75 23.5858 24.4142 23.25 24 23.25C23.5858 23.25 23.25 23.5858 23.25 24V30C23.25 30.4142 23.5858 30.75 24 30.75C24.4142 30.75 24.75 30.4142 24.75 30V24ZM19 26.25C19.4142 26.25 19.75 26.5858 19.75 27V30C19.75 30.4142 19.4142 30.75 19 30.75C18.5858 30.75 18.25 30.4142 18.25 30V27C18.25 26.5858 18.5858 26.25 19 26.25Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradechartIcon);
export default __webpack_public_path__ + "static/media/tradechartIcon.c7c1728f27faf992ea05f44055d9d9bf.svg";
export { ForwardRef as ReactComponent };